import Vue from 'vue'

// Filter Thai bath
Vue.filter('thaiBath', function (value) {
  if (value) {
    return Number.parseFloat(value).toLocaleString('th-TH')
  } else return 0
})

Vue.filter('thaiBath2Digit', function (value) {
  if (value) {
    return Number.parseFloat(value).toLocaleString('th-TH', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  } else return 0
})

// Filter Thai bath - 2 decimal places, decimals hidden when they are .00
Vue.filter('thaiBathMax2Digit', function (value) {
  if (value) {
    const num = Number.parseFloat(value)
    const decimals = num.toFixed(2) % 1 === 0 ? 0 : 2
    return num.toLocaleString('th-TH', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: 2,
    })
  } else return 0
})

// Filter Thai date
Vue.filter('thaiDate', function (value) {
  var d = new Date(value),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear() + 543

  if (month.length < 2) month = '0' + month
  if (day.length < 2) day = '0' + day

  return [day, month, year].join('/')
})

// yyyy-mm-dd date filter
Vue.filter('date', function (value) {
  var d = new Date(value),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear()

  if (month.length < 2) month = '0' + month
  if (day.length < 2) day = '0' + day

  // Check format for
  return [year, month, day].join('-')
})

// Validate Phone
Vue.filter('validatePhone', function (phone) {
  const re = /^[\\+]?[(]?[0-9]{3}[)]?[-\s\\.]?[0-9]{3}[-\s\\.]?[0-9]{4}$/im

  return re.test(phone)
})

// Format Phone to xxx-xxx-xxxx
Vue.filter('phoneFormat', function (phone) {
  if (!phone) return ''

  // Remove all non-digit characters
  const cleaned = phone.replace(/\D/g, '')

  // Check if we have exactly 10 digits
  if (cleaned.length === 10) {
    return cleaned.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
  }

  // Return original if not 10 digits
  return phone
})

// Validate Email
Vue.filter('validateEmail', function (email) {
  if (email) {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(String(email).toLowerCase())
  }
})

// Validate laserId
Vue.filter('validateLaserId', function (laserId) {
  if (laserId.length !== 12) return false
  if (laserId) {
    const re = /^([A-Z]{2})+([0-9]{10})$/
    return re.test(laserId)
  }
})

// Validate citizenId
Vue.filter('validateCitizenId', function (citizenId) {
  if (citizenId.length !== 13) return false
  let sum = 0
  for (let i = 0; i < 12; i++) {
    sum += parseInt(citizenId.charAt(i)) * (13 - i)
  }
  const mod = sum % 11
  const check = (11 - mod) % 10
  if (check === parseInt(citizenId.charAt(12))) {
    return true
  }
  return false
})
